import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VBtn,{attrs:{"rounded":"","text":_vm.text,"dark":"","fab":_vm.fab,"color":_vm.color,"small":_vm.small,"x-small":_vm.xsmall,"large":_vm.large,"x-large":_vm.xlarge,"disabled":_vm.disabled,"href":_vm.href,"outlined":_vm.outlined},on:{"click":function($event){return _vm.buttonClicked()}}},[_c(VIcon,{attrs:{"left":_vm.fab ? false : true}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.fab ? "" : _vm.label)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }